'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Featured Nav
 *    Scripts for the Homepage Featured Nav section.
 *
 *  Version:
 *    1.0.0 - 2020/07/07
 */

var CONTAINER_SELECTOR = '[data-featured-nav]';
var LINK_SELECTOR = '[data-featured-nav-link]';
var SUBMENU_SELECTOR = '[data-featured-nav-submenu]';
var MOBILE_TOGGLE_SELECTOR = '[data-featured-nav-mobile-toggle]';
var MOBILE_MENU_SELECTOR = '[data-featured-nav-menu]';

var FeaturedNav = function () {
  function FeaturedNav(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, FeaturedNav);

    this.container = container;
    this.links = container.find(LINK_SELECTOR);
    this.submenus = container.find(SUBMENU_SELECTOR);
    this.mobileMenu = container.find(MOBILE_MENU_SELECTOR);

    container.on('mouseenter', LINK_SELECTOR, function (e) {
      return _this.hoverLink(e);
    });
    container.on('mouseleave', function () {
      return _this.unhoverLink();
    });
    container.on('click touchend', MOBILE_TOGGLE_SELECTOR, function (e) {
      return _this.onMobileToggleClick(e);
    });
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    this.onResize();
  }

  (0, _createClass3.default)(FeaturedNav, [{
    key: 'hoverLink',
    value: function hoverLink(e) {
      var self = $(e.currentTarget);
      var handle = self.attr('data-handle');

      this.links.removeClass('is-active');
      self.addClass('is-active');

      this.submenus.removeClass('is-active');
      this.submenus.each(function (_, submenu) {
        if ($(submenu).attr('data-handle') != handle) return;
        $(submenu).addClass('is-active');
        return false;
      });
    }
  }, {
    key: 'unhoverLink',
    value: function unhoverLink() {
      this.links.removeClass('is-active');
      this.submenus.removeClass('is-active');
    }
  }, {
    key: 'onMobileToggleClick',
    value: function onMobileToggleClick(e) {
      e.preventDefault(), e.stopPropagation();
      var self = $(e.currentTarget);
      if (self.hasClass('is-active')) {
        self.removeClass('is-active');
        this.mobileMenu.removeClass('is-active');
        return;
      }
      self.addClass('is-active');
      this.mobileMenu.addClass('is-active');
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.submenus.css('max-height', this.container.height());

      if ($(window).width() < ResponsiveSizes.medium) return;
      this.mobileMenu.addClass('is-active');
      this.mobileMenu.prev(MOBILE_TOGGLE_SELECTOR).addClass('is-active');
    }
  }]);
  return FeaturedNav;
}();

(0, _ShopifySection.register)(CONTAINER_SELECTOR, FeaturedNav);